// @ts-strict-ignore
import React, {useState} from 'react';

import {QueryMultiMetricEntry, SelectorTypeDefinitions} from 'common/query-builder/query-entry-section/types';
import {MenuType, MultiMetricsSectionItem} from 'common/query-builder/query-block/multi-metrics-menu/types';
import {RowSelector} from 'iron/common/query-builder/query-entry-section/components/selector';

import {BaseEntryRow} from '../base';
import type {EntryRowProps} from '../types';
// eslint-disable-next-line import/no-cycle
import {helpers} from './helpers';

export function MultiMetricsEntryRow(props: EntryRowProps<QueryMultiMetricEntry>) {
  const [entryEl, setEntryEl] = useState<HTMLDivElement>(null);

  const handleSelect = (item: MultiMetricsSectionItem) => {
    helpers.handleRowSelect(props, item, null);
  };

  const handleCreateInline = (menuType: MenuType) => {
    helpers.handleRowCreate(props, menuType);
  };

  const selectorRenderer = () => (
    <RowSelector
      {...props}
      contextPanelParentElement={entryEl}
      isPlaceholder
      selectorType={SelectorTypeDefinitions.Metrics}
      onSelect={(sectionItem) => handleSelect(sectionItem)}
      onCreate={(ev: {detail: {item: MenuType}}) => handleCreateInline(ev.detail.item)}
    />
  );

  return (
    <BaseEntryRow
      ref={setEntryEl}
      {...props}
      isPlaceholder={false}
      renderSelector={selectorRenderer}
      overflowControls={[]}
      entryIcon={null}
    />
  );
}
